export default {
    LOAD_HOME(state, home) {
        state.items = home;
    }
}